import React from 'react'

export const InputLabel: React.FC<{label: string, labelIsWhite?: boolean}> = ({label, labelIsWhite}) => {
  return <p className={`text-[14px] leading-[16px] font-semibold ${labelIsWhite ? "text-white" : "text-primary"} mb-[12px]`} >{label}</p>;
}
